import React, { Component } from "react";
import CardSection from "../../components/common/cardSection/CardSection";
import FieldManagementServices from "../../services/axiosServices/apiServices/FieldManagementServices";
import SwalServices from "../../services/swalServices/SwalServices";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../components/dropdown/DropdownAction";
import Table from "../../components/table/Table";
import CommitteeMembers from "./CommitteeMembers";
import ModalBasic from "../component/ModalBasic";
import { getAuditContext } from "../../utils/audit/AuthenticationLibrary";


export default class MembershipCommittee extends Component {
    constructor(props) {
        super(props);
        this.FieldManagementServices = new FieldManagementServices();
        this.swalServices = new SwalServices();
        this.state = {
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "",
                orderFlag: 0,
                searchText: "",
                isMembershipCommittee: true,
            },
            isLoading: false,
            committeeMemberList: [],
            actionDropdown: ["Edit", "Delete"],
            setAddeditModalOpen: false,
            totalResultes: "",
            committeeMemberDetails: {
                committeeMemberId: 0,
                isMembershipCommittee: false,
                salutationId: 0,
                name: "",
                email: "",
            },
            salutationDropdown: [],

        };
    }

    componentDidMount() {
        let audit = getAuditContext();

        this.getAllCommitteeMembersList();
        this.getAllCommitteeMemberDropdown();
        this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

    }

    getAllCommitteeMembersList = () => {
        const { pagination } = this.state;

        this.FieldManagementServices.getAllCommiteeMembersList(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem) {
                let committeeMembers = response.responseItem.responseContent.itemList.filter(
                    (item) => item.isMembershipCommittee === true
                );
                console.log("committeeMembers", committeeMembers);
                this.setState(
                    { committeeMemberList: committeeMembers },
                    () => {
                        console.log("Updated Committee List:", this.state.committeeMemberList);
                    }
                );
                this.setState({
                    totalResultes: response.responseItem.responseContent.totalCount,
                });
            } else {
                console.warn("Unexpected API response:", response);
            }
        })
            .catch((error) => {
                console.error("Error fetching committee members:", error);
            });
    };

    setPagination = (newPagination) => {
        this.setState({ pagination: newPagination });
        this.getAllCommitteeMembersList(newPagination);
    };

    actionClick = (index, value, option, event) => {

        if (option === "Edit") {
            var id = this.state.committeeMemberList[index].committeeMemberId;
            if (this.state.committeeMemberList && this.state.committeeMemberList[index]) {
                this.setState(
                    { selectedTaskId: this.state?.committeeMemberList[index]?.committeeMemberId },
                    () => {

                        this.selectTask(id, event);
                    }
                );
            }
        } else if (option === "Delete") {
            // return false
            this.deleteCommitteeMemberById(value);
        }
    };
    actions = (element, index, value) => {
        return element !== "committeeMemberId" ? null : (
            <td>
                <ActionContainer>
                    <DropdownAction
                        key={index}
                        value={value}
                        id={index}
                        index={index}
                        options={this.state.actionDropdown}
                        align="right"
                        onOptionClick={this.actionClick.bind(this)}
                    />
                </ActionContainer>
            </td>
        );
    };

    selectTask = (value, e) => {
        e.stopPropagation();
        this.setState({ setAddeditModalOpen: true, selectedTaskId: value });
        this.getCommiteeMemberDetailsById(value);
    };
    getCommiteeMemberDetailsById = (id) => {

        this.FieldManagementServices.getCommiteeMemberDetailsById(id).then((response) => {

            if (response.statusCode === 200 && response.responseItem != null) {
                console.log("response", response.responseItem.responseContent);
                this.setState({ committeeMemberDetails: response.responseItem.responseContent });
            }
        })
    }

    handleModalPopup = () => {
        const { setAddeditModalOpen } = this.state;
        this.setState({ setAddeditModalOpen: !setAddeditModalOpen })
    }


    handleChange = (event) => {

        const value = event.target.value;
        const name = event.target.name;
        let detail = this.state.committeeMemberDetails;
        detail[name] = value;
        this.setState({ committeeMemberDetails: detail });
        console.log("handleChange response", this.state.committeeMemberDetails);
    }

    handleAdd = () => {
        this.setState({ setAddeditModalOpen: true, committeeMemberDetails: { name: "", email: "" } });
    }


    setFilterParameters = (id, drpIdentity) => {

        let detail = this.state.committeeMemberDetails;

        if (drpIdentity === "SalutationName") {
            detail["salutationId"] = id;
        }
        this.setState({ committeeMemberDetails: detail });
    }

    getAllCommitteeMemberDropdown = () => {
        this.setState({ isLoading: true });
        this.FieldManagementServices.getAllCommitteeMemberDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {

                let committeeDropdown = response.responseItem.responseContent.filter(
                    (drp) => drp.dropdownName === "salutationName"
                );

                this.setState({ salutationDropdown: committeeDropdown }, () => this.getAllCommitteeMembersList());
            } else {
                this.getAllCommitteeMembersList();
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });
    };

    addEditCommitteeMemberDetails = () => {
        const audit = getAuditContext()


        let request = this.state.committeeMemberDetails;
        request.committeeMemberId = this.state.committeeMemberDetails.committeeMemberId;
        request.salutationId = this.state.committeeMemberDetails.salutationId;
        request.name = this.state.committeeMemberDetails.name;
        request.email = this.state.committeeMemberDetails.email.replace(/\s+/g, '');;
        request.isMembershipCommittee = true;
        request.updatedBy = audit.adminUserId;
        request.updatedAppId = audit.appId

        if (request.name === '') {
            this.swalServices.Error("Please Enter Name");
            return
        }
        else if (request.email === '') {
            this.swalServices.Error("Please Enter Email");
            return
        }
        else {
            this.FieldManagementServices.addEditCommitteeMemberDetails(request).then((response) => {

                if (response.statusCode === 200 && response.responseItem != null) {
                    if (response.responseItem.responseContent.errorMessage === "Email already exist") {
                        this.swalServices.Warning("Email already exist,");
                        this.setState({ setAddeditModalOpen: false });
                        this.getAllCommitteeMembersList();
                    } else if (response.responseItem.responseContent.errorMessage === "Member update successfully") {
                        this.swalServices.Success("Committee Member update successfully!");
                        this.setState({ setAddeditModalOpen: false });
                        this.getAllCommitteeMembersList();
                    }
                    else {
                        this.swalServices.Success("Commitee member added successfully!");
                        this.setState({ setAddeditModalOpen: false });
                        this.getAllCommitteeMembersList();
                    }
                } else {
                    this.swalServices.Error(response.message);
                }
            })
        }
    }

    deleteCommitteeMemberById = (value) => {
        const audit = getAuditContext()
        let request = {
            id: value,
            deletedBy: audit.adminUserId,
            appId: audit.appId
              }
              debugger
        this.FieldManagementServices.deleteCommitteeMemberById(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                this.swalServices.Success("Committee Member deleted successfully!");
                this.setState({ setAddeditModalOpen: false });
                this.getAllCommitteeMembersList();
            }
        })
    }
    render() {
        return (
            <>
                <div className="main-body-section ">
                    <div className="bg-white pl-8 pt-10 pb-5">
                        <div className="add-btn-sec">
                            <button className={`py-2 w-[250px] btn btn-lighblue text-lg rounded-md text-white font-bold `}
                                onClick={() => this.handleAdd()}
                            >
                                +  Add
                            </button>
                        </div>
                        <main className="pb-10">
                            <div className="w-full mx-auto">
                                <div className="relative">
                                    <div>
                                        <div className=" mt-12">
                                            <Table
                                                columns={[
                                                    { name: "name", title: "Name" },
                                                    { name: "email", title: "Email Address" },
                                                    { name: "committeeMemberId", title: "Action" },
                                                ]}
                                                pagination={this.state.pagination}
                                                rows={this.state.committeeMemberList}
                                                sortingColumns={[""]}
                                                isLoading={this.state.isLoading}
                                                totalResultes={this.state.totalResultes}
                                                totalCount={this.state.totalResultes}
                                                setPagination={this.setPagination.bind(this)}
                                                customScope={[
                                                    {
                                                        column: "committeeMemberId",
                                                        renderTableData: this.actions.bind(this),
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
                <div className="member-task-process committee-members-modal">
                    <ModalBasic
                        id="editMemberShipCommittee"
                        modalOpen={this.state.setAddeditModalOpen}
                        className="committee-members-modal"
                        setModalOpen={() => this.handleModalPopup()}
                        title="Membership Committee Members"
                    >
                        <CommitteeMembers
                            committeeMemberDetails={this.state.committeeMemberDetails}
                            handleChange={(event) => this.handleChange(event)}
                            salutationDropdown={this.state.salutationDropdown}
                            setFilterParameters={(id, drpIdentity) => this.setFilterParameters(id, drpIdentity)}
                            addEditCommitteeMember={() => this.addEditCommitteeMemberDetails()}
                            deleteCommitteeMemberById={() => this.deleteCommitteeMemberById()}
                        />
                    </ModalBasic>
                </div>
            </>
        );

    }
}

